export default {
  'dispatches.menuTitle': 'Dispatches',
};
